export default {
  "content": "<g clip-path=\"url(#a)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.667 6.653V4.97a8.673 8.673 0 00-3.798 5.458.298.298 0 01-.576.03A6.213 6.213 0 012 8.567a6.346 6.346 0 014.667-6.096V.484a.487.487 0 01.77-.393l4.359 3.085a.48.48 0 010 .785L7.437 7.046a.488.488 0 01-.77-.393zm7.04-1.11c.194.61.293 1.248.293 1.89a6.345 6.345 0 01-4.667 6.095v1.989a.487.487 0 01-.77.393l-4.359-3.085a.48.48 0 010-.785l4.359-3.085a.487.487 0 01.77.393v1.683a8.672 8.672 0 003.798-5.46.298.298 0 01.576-.028z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};